export default __webpack_public_path__ + "static/media/portfolio-wilo-6.a2b55e5f.jpg";